// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2cyAo","topBottomGutter":"Layout_topBottomGutter__32rzH"};